import { PRODUCTS, type Product } from './products'

export type PartnerProfile = {
  code: string
  slug: string
  name: string
  region: string
  focus: string
  intro: string
  proof: string[]
  productSlugs: string[]
}

export const PARTNERS: PartnerProfile[] = [
  {
    code: 'QRD-DEMO-000',
    slug: 'demo',
    name: 'Demo Partner Shop',
    region: 'Sample region (for demonstration)',
    focus: 'A sample partner storefront showing how the catalog looks to a referred owner',
    intro:
      'This is a demonstration partner shop. It shows how a partner storefront looks — a focused shelf of working product demos, a referral code, and a join CTA. Every demo linked here is live and clickable.',
    proof: ['Sample shop for walkthroughs', 'All demos below are live', 'Shows the referral + lead flow'],
    productSlugs: ['barbershop', 'car-rental', 'restaurant', 'coffee-bar', 'tile-workers', 'custom'],
  },
  {
    code: 'QRD-DJ-001',
    slug: 'djoko',
    name: 'Djoko MyClienta',
    region: 'Denmark, Romania, Macedonia',
    focus: 'AI automation demos for small local businesses',
    intro:
      'A curated starter shop for owners who want to see what an AI-powered booking, ordering, rental, or lead-capture system could look like before committing.',
    proof: ['40 catalog concepts', '9 live demo families', 'Referral commission tracked from first lead'],
    productSlugs: ['barbershop', 'car-rental', 'restaurant', 'veterinarian', 'cleaning-service', 'custom'],
  },
  {
    code: 'QRD-MK-104',
    slug: 'se-macedonia',
    name: 'SE Macedonia Demo Desk',
    region: 'Gevgelija and regional businesses',
    focus: 'Hospitality, trades, wineries, and appointment businesses',
    intro:
      'A regional storefront for showing local owners practical software demos in their own business category, then routing interested leads back to Qordo Catalog.',
    proof: ['Built for local referral selling', 'Demo-first conversations', 'No paid ads required to start'],
    productSlugs: ['pizzeria', 'winery', 'tile-workers', 'hair-salon', 'bakery', 'custom'],
  },
  {
    code: 'QRD-RO-220',
    slug: 'bucharest-services',
    name: 'Bucharest Service Stack',
    region: 'Bucharest and Romania',
    focus: 'High-ticket service businesses and rental operators',
    intro:
      'A focused shop for owners who need online booking, intake, fleet availability, quotes, or customer follow-up without buying a large SaaS suite.',
    proof: ['High-ticket verticals first', 'Service and rental demos', 'Partner-ready lead capture'],
    productSlugs: ['dentist', 'pet-shop', 'car-rental', 'equipment-rental', 'lawyer', 'custom'],
  },
]

export function productsForPartner(partner: PartnerProfile): Product[] {
  return partner.productSlugs
    .map((slug) => PRODUCTS.find((product) => product.slug === slug))
    .filter((product): product is Product => Boolean(product))
}

export function findPartner(slugOrCode: string | undefined): PartnerProfile | undefined {
  const needle = (slugOrCode ?? '').toLowerCase()
  return PARTNERS.find((partner) => partner.slug === needle || partner.code.toLowerCase() === needle)
}
